import { Button } from '@douyinfe/semi-ui';
import { IconDownload } from '@douyinfe/semi-icons';
import { useGo } from '../../../../hook/useGo';
import { useLocale } from '../../../../locales';
import './header.scss';

const BrowserExtensionEntry = () => {
  const { go } = useGo();
  const { formatMessage } = useLocale();

  const handleOpenGuide = () => {
    go({ path: '/extension' });
  };

  return (
    <div className='store-ops-header-extension-entry'>
      <Button
        theme='borderless'
        type='primary'
        icon={<IconDownload />}
        onClick={handleOpenGuide}
        className='store-ops-header-extension-entry__link'
      >
        <span className='store-ops-header-extension-entry__text'>
          {formatMessage({ id: 'web.menu.extension' })}
        </span>
        <span className='store-ops-header-extension-entry__new'>NEW</span>
      </Button>
    </div>
  );
};

export default BrowserExtensionEntry;
